import { applyMiddleware, createStore, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import { createBrowserHistory } from 'history';
import thunk from 'redux-thunk';

import indexReducer from './Reducers/index';

export const history = createBrowserHistory();
const enhancers=[];

const middleware=[
    thunk,
    routerMiddleware(history),
];
if (process.env.NODE_ENV === 'development') {
    const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();

    if (typeof devToolsExtension === 'function') {
        enhancers.push(devToolsExtension)
    }
}
const composeEnhancers = compose(
    applyMiddleware(...middleware),
    ...enhancers
);


export default createStore(indexReducer,composeEnhancers);